import AdicionalService from "@/services/AdicionalService";

export const adicional = {
  namespaced: true,
  state: {
    adicional: {},
  },
  actions: {
    getAdicional({ commit }, payload) {
      return AdicionalService.GetAdicional(payload).then(
        (adicional) => {
          return Promise.resolve(adicional);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postAdicional({ commit }, payload) {
      return AdicionalService.PostAdicional(payload).then(
        (adicional) => {
          return Promise.resolve(adicional);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putAdicional({ commit }, payload) {
      return AdicionalService.PutAdicional(payload).then(
        (adicional) => {
          return Promise.resolve(adicional);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteAdicional({ commit }, payload) {
      return AdicionalService.DeleteAdicional(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getAdicionalOData({ commit }, payload) {
      return AdicionalService.GetAdicionalOData(payload).then(
        (adicional) => {
          return Promise.resolve(adicional);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default adicional;
